import { useEffect, useRef, useState } from "react";
import { Clapperboard, PlayCircle, Youtube } from "lucide-react";
// import video from "../../../public/videos/corporate-hero.mp4";

const HERO_SECTION_STYLE = { maxHeight: "100vh" };
const HERO_LEAD_STYLE = {
  color: "#f7f7f7",
  maxWidth: "650px",
  lineHeight: "1.6",
};
const WORK_LINKS = [
  {
    href: "https://vimeo.com/hkimedia",
    label: "Vimeo",
    icon: PlayCircle,
  },
  {
    href: "https://www.youtube.com/@Hki_music",
    label: "YouTube Channel",
    icon: Youtube,
  },
];

const Hero = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <section className="corporate_hero_bg" style={HERO_SECTION_STYLE}>
      <video className="hero-bg-video" autoPlay loop muted playsInline controls>
        <source
          src="https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hero/corporate-hero.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>

      <div className="hero-overlay" />

      <div className="container position-relative z-2 text-center mb-3">
        <div className="row justify-content-center">
          <div className="col-lg-10 col-xl-8">
            <span className="text-accent small d-block mb-2 text-uppercase tracking-wider">
              HKI Media Corporate
            </span>

            <h1 className="hero-title mb-2">
              CORPORATE MEDIA <br />
              SOLUTIONS FOR <br />
              <span style={{ color: "var(--text-light)" }}>
                MODERN BUSINESSES
              </span>
            </h1>

            <p className="lead mb-3 mx-auto" style={HERO_LEAD_STYLE}>
              We engineer structured, high-quality media experiences that drive
              engagement and establish authority for leading enterprises.
            </p>

            <div className="d-flex justify-content-center gap-3">
              <div className="cta-dropdown-wrapper" ref={dropdownRef}>
                <button
                  type="button"
                  className="btn-corporate-primary"
                  onClick={() => setIsDropdownOpen((open) => !open)}
                  aria-expanded={isDropdownOpen}
                >
                  <span>Our Work</span>
                  <Clapperboard size={24} />
                </button>

                <div
                  className={`cta-dropdown-menu ${isDropdownOpen ? "active" : ""}`}
                >
                  {WORK_LINKS.map(({ href, label, icon: Icon }) => (
                    <a
                      key={href}
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cta-dropdown-item"
                    >
                      <Icon size={18} />
                      <span>{label}</span>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
